// Visual feedback for native HTML5 validation. Drupal core renders the
// "required" attribute on required fields regardless of theme, so the
// browser's own constraint validation blocks a submit with an empty
// required field *before* it ever reaches Drupal - meaning Drupal's own
// server-side ".form-item--error"/".is-invalid" classes (styled in
// form-element.scss) never get a chance to render for that common case.
// CSS ":user-invalid" would be the declarative fix, but it doesn't fire
// reliably yet - so this listens for the native "invalid" event (which
// does fire, on every submit attempt) and toggles a class instead.
(() => {
  document.addEventListener(
    'invalid',
    (event) => {
      const field = event.target;
      if (!field.classList || !field.classList.contains('form-control')) {
        return;
      }
      field.classList.add('client-invalid');
    },
    true, // "invalid" doesn't bubble - capture instead.
  );

  document.addEventListener('input', (event) => {
    const field = event.target;
    if (field.classList && field.classList.contains('client-invalid') && field.validity.valid) {
      field.classList.remove('client-invalid');
    }
  });
})();
